export default __webpack_public_path__ + "static/mp-353753fc1862dd16b40025358465eb99.svg";